import { render, staticRenderFns } from "./lock-screen-1.vue?vue&type=template&id=1ecb3678"
import script from "./lock-screen-1.vue?vue&type=script&lang=js"
export * from "./lock-screen-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports